export default __webpack_public_path__ + "static/media/clock_s.54c9b542.svg";